import { StatsStoreKeys } from './constants';

export const selectTTMEvents = state => state.stats.get(StatsStoreKeys.TTM_EVENTS);
export const selectSkipType = state =>
  state.stats.getIn([StatsStoreKeys.PERFORMANCE, StatsStoreKeys.SKIP_TYPE]);
export const getPreviousPlayedHarness = state =>
  state.stats.get(StatsStoreKeys.PREVIOUS_PLAYED_HARNESS);
